import { z } from "zod";

export const eventSchema = z.object({
  id: z.number(),
  type: z.enum([
    "APP_LOCATION_SCAN",
    "APP_ORDERPICK",
    "APP_PACKINGSLIP",
    "DBB_REQUEST",
    "ROUTE_GENERATED",
    "REQUEST_ADD_TO_EXISTING_ROUTE",
    "ROUTE_DEFINITIVE",
  ]),
  user: z.object({
    username: z.string(),
  }),
  updated_by: z.object({
    username: z.string(),
  }),
  source_type: z.string(),
  source: z.object({
    __typename: z.string(),
    "... on Tireset": z.object({
      id: z.string(),
      label: z.string(),
      car: z.object({
        id: z.number(),
        licence: z.string(),
      }),
    }),
    "... on Car": z.object({
      id: z.string(),
      licence: z.string(),
      label: z.string(),
    }),
    "... on Position": z.object({
      id: z.string(),
      label: z.string(),
    }),
    "... on Request": z.object({
      id: z.string(),
      label: z.string(),
      source: z.object({
        "... on Tireset": z.object({
          car: z.object({
            licence: z.string(),
          }),
        }),
      }),
    }),
  }),
  raw_source: z.number(),
  status: z.enum(["NEW", "COMPLETED", "REJECTED"]),
  message: z.string(),
  created_at: z.date(),
});

export type EventModel = z.infer<typeof eventSchema>;
